'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.offers = void 0;
var tslib_1 = require("tslib");
var adapter_1 = require("../adapter");
var Offers = /** @class */ (function () {
    function Offers() {
    }
    /**
     * Get offer by slug
     */
    Offers.prototype.get = function (lang, slug) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var params, offer;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = { slug: slug, lang: lang };
                        return [4 /*yield*/, adapter_1.adapter.offers.get(params)];
                    case 1:
                        offer = _a.sent();
                        if (!offer || offer.length === 0) {
                            throw new Error('Offer not found');
                        }
                        return [2 /*return*/, offer[0]];
                }
            });
        });
    };
    /**
     * Get all offers
     */
    Offers.prototype.getAll = function (lang) {
        var params = { lang: lang };
        return adapter_1.adapter.offers.getAll(params);
    };
    /**
     * Opt in for offer
     */
    Offers.prototype.optIn = function (slug, lang, cta, userName) {
        var params = { slug: slug, lang: lang, cta: cta, userName: userName };
        return adapter_1.adapter.offers.optIn(params);
    };
    return Offers;
}());
exports.offers = new Offers();
